/**
 * Call Direction
 */
export enum CallDirection {
  /**
   * Caregiver to Senior.
   */
  CaregiverToSenior = 'caregiver-to-senior',

  /**
   * Senior to Caregiver.
   */
  SeniorToCaregiver = 'senior-to-caregiver',

  /**
   * Caregiver to Caregiver.
   */
  CaregiverToCaregiver = 'caregiver-to-caregiver',

  /**
   * Senior to Senior.
   */
  SeniorToSenior = 'senior-to-senior',
}
